module.exports = {
    DropModal: require('./DropModal'),
    WaveModal: require('./WaveModal'),
    FlyModal: require('./FlyModal'),
    FadeModal: require('./FadeModal'),
    ScaleModal: require('./ScaleModal'),
    OutlineModal: require('./OutlineModal'),
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/boron/Boron.js
// module id = 685
// module chunks = 0